import { useTranslation } from "react-i18next";
import { ScoreType, useGetAllScoreType } from "src/api/client-api/scoreType/useGetAllScoreType";
import { useUpdateScoreType } from "src/api/client-api/scoreType/useUpdateScoreType";
import { ColumnsService } from "src/utils/ColumnsService";
import { useSnackbar } from "src/utils/useSnackbar";
import { getScoreTypeSelection, ScoreTypeSelection } from "../utils/scoreTypeSettings";

const haveSameIds = (left: number[], right: number[]): boolean =>
    left.length === right.length && left.every((id, index) => id === right[index]);

export const useScoreTypeSettings = (type: ScoreType["type"]) => {
    const { t } = useTranslation();
    const snackbar = useSnackbar();
    const { scoreTypes } = useGetAllScoreType();
    const updateScoreType = useUpdateScoreType({
        onSuccess: (saved, previous) => {
            const savedScoreIds = saved.scoreIds ?? [];
            if (!haveSameIds(previous?.scoreIds ?? [], savedScoreIds)) {
                ColumnsService.updateScoresColumnsSettings(saved.type, savedScoreIds);
            }
            snackbar.setSnackbarProps({
                type: "success",
                message: t("settings.scores.updated", "Scores mis à jour avec succès"),
            });
        },
        onError: () => {
            snackbar.setSnackbarProps({
                type: "error",
                message: t("settings.error", "Erreur lors de la sauvegarde des scores"),
            });
        },
    });

    const selection = getScoreTypeSelection(scoreTypes?.find((scoreType) => scoreType.type === type));

    const save = (next: ScoreTypeSelection) => updateScoreType.mutate({ type, ...next });

    return { selection, save };
};
